function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#D1D1D6",
  d: "M25.513 12.217L1.294.097C.61-.245-.166.373.031 1.104l2.887 10.76c.091.34.378.593.73.644l3.38.492-3.38.492c-.352.052-.639.305-.73.644L.031 24.896c-.197.732.58 1.35 1.263 1.007l24.22-12.12c.65-.326.647-1.242 0-1.566zM2.26 23.451l2.23-8.306 8.761-1.277c.437-.063.76-.433.76-.868s-.323-.805-.76-.869L4.49 10.855 2.26 2.55 23.143 13 2.26 23.452z"
});

var SvgSendIcn = function SvgSendIcn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSendIcn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/send-icn.e947cd86.svg";
export { ForwardRef as ReactComponent };